import React, { useState } from 'react';
import { Balance } from 'common/components/PersonProfile/components';
import { IBalanceSummary } from 'common/components/PersonProfile/interfaces';
import { useLazyGetBalanceSummary } from 'modules/members/api/balance.api';

interface IBalanceProps {
  balance: string;
  reward: number;
  pastDuse: number;
  totalBalance: number;
  personId: number;
}

const BalanceContainer: React.FC<IBalanceProps> = ({
  balance,
  reward,
  pastDuse,
  totalBalance,
  personId,
}) => {
  const [balanceSummary, setBalanceSummary] = useState<IBalanceSummary | undefined>();

  const [getBalanceSummaryRequest] = useLazyGetBalanceSummary();

  const getBalanceSummary = () => {
    getBalanceSummaryRequest(personId)
      .unwrap()
      .then(response => {
        if (response) {
          setBalanceSummary(response);
        }
      })
      .catch(() => {});
  };

  return (
    <Balance
      balance={balance}
      reward={reward}
      pastDuse={pastDuse}
      totalBalance={totalBalance}
      getBalanceSummary={getBalanceSummary}
      balanceSummary={balanceSummary}
    />
  );
};

export default BalanceContainer;
